export default __webpack_public_path__ + "static/media/connection.d66f56a1.svg";